import React, {useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useToken } from '../contex/TokenProvider';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import '../Style/Properties.css';
import BaseUrl from '../api/BaseUrl';



function Properties() {

  const {token} = useToken();

  const [property, setProperty] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  // const token = localStorage.getItem('token');


  useEffect(() => { 
     setLoading(true);
     setErrorMessage('');
     BaseUrl.get('/Property/get-all-properties')  
     .then(res => {
      setProperty(res.data.data)
      setLoading(false);
    })  
     .catch(err => {
      console.log(err)
      setErrorMessage(err.res.data.message);
      setLoading(false);
    });
  }, [token]); 

  const handleDelete = (propertyId) => {
    const confirm = window.confirm('Are you sure you want to delete this property?');
    if(confirm) {
      BaseUrl.delete(`/Property/delete-property/${propertyId}`, {
      headers: {
        'Authorization' : `Bearer ${token}`,
      }  
      })
      .then(res => {    
        if (res.status === 200 || res.status === 204) {    
          setProperty(prevProperty => prevProperty.filter(property => property.propertyId !== propertyId));  
        } else {  
          setErrorMessage('Failed to delete image. Please try again.');  
        }  
      })  
      .catch(err => {  
        console.log(err);  
        setErrorMessage('Error deleting image.');  
      });  
    }
  }

  return (
    <div className='mt-[100px] ml-[100px] '>
      <div className=''>

        <Link to={'/addproperties'} className='mx-auto mt-5 mb-10 flex flex-row justify-between items-center text-green-500 px-10 py-3 shadow-lg bg-slate-100 w-[500px]'>
          <h1 className='text-[18px] font-bold'>Add Property</h1>
          <p className='text-[25px] font-bold'>+</p>
        </Link>

        {errorMessage && <p className='text-center text-red-500 text-[18px] font'>{errorMessage}</p>}

        {loading ? <AiOutlineLoading3Quarters className='proloading mt-[100px] text-[30px] mx-auto'/> : 
        <div className='py-10 flex flex-row flex-wrap gap-5'>
          {property.map((d) => {
            return (
              <div className='flex flex-col gap-5 w-[350px]  bg-slate-100 py-5 px-5 rounded-tl-1xl' key={d.propertyId}>
                <div className='w-[250px] mx-auto'>
                  <img className='w-[100%] rounded-tl-lg rounded-tr-lg' src={d.image} alt='image' />
                </div>
                <div className='flex flex-col items-center justify-center'>
                  <h1 className='font-bold text-[20px]'>{d.title}</h1>
                  <p>{d.address}</p>
                </div>

                <div className='flex flex-row gap-2 px-10 py-3 bg-slate-200 items-center justify-center rounded-lg'>
                  <Link className='px-2 py-1 bg-slate-500 text-white rounded-lg' to={`/viewproperties/${d.propertyId}`}>View</Link>
                  <Link className='px-2 py-1 bg-green-500 text-white rounded-lg' to={`/editproperties/${d.propertyId}`}>Edit</Link>
                  <button onClick={e => handleDelete(d.propertyId)} className='px-2 py-1 bg-red-500 text-white rounded-lg'>Delete</button>
                </div>
              </div>
            )
          })}
        </div>}
      </div>
      

    </div>
  )
}

export default Properties
